import { useCallback, useEffect, useState } from 'react';
import gamesService from '../../../../services/gamesService';
import type { MissingGame } from '../../../../types/features/games';

export const useMissingGames = () => {
  const [games, setGames] = useState<MissingGame[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadGames = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await gamesService.getMissingGames();
      setGames(response.data || []);
    } catch (loadError) {
      setError(loadError instanceof Error ? loadError.message : 'Failed to load missing games');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadGames();
  }, [loadGames]);

  return { games, loading, error, reload: loadGames };
};
